module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction: The Queen")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What neurologists do")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Six Improbable Things Before Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Arrivals, departures, and delays on the ward")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like a Hole in the Head")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Where baseball and neurology converge in a game-saving, over-the-shoulder catch")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("3.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The State of Confusion")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Two characters in search of a neurologist")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("4.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Man Godfrey")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A poor sort of memory that only works backwards")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("5.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Seems to Be the Problem?")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A politically incorrect guide to malingering, shamming, and hysteria")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("6.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do No Harm")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A walking time bomb tests the limits of good sense")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("7.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Story Is Worth a Thousand Pictures")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nine songs of innocence and experience")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("8.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endgame")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Facing down Lou Gehrig’s disease")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("9.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Examined Life")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What it takes to survive a motor-neuron death sentence")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("10.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curse of the Werewolf")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("On the front lines in the battle against Dr. Parkinson’s disease")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("11.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For the Want of a Nail")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A hard-knock lesson on the way to the morgue")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("12.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eyes Have It")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("When is somebody not dead yet?")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("13.")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boats Against the Current")])]), _vm._v(" "), _c('p', {
    staticClass: "CCST"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Based on a true story")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Dr. Allan H. Ropper and Brian David Burrell")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 62
// module chunks = 0